import { constantRouterMap } from '@/router';
import Layout from '@/views/layout/Layout';
import EmptyLayout from '@/views/layout/EmptyLayout';
// import { changeIcon } from '@/utils'
const groupRoutes = (data) => {
  const parentPath = data.item.url.indexOf('?') > -1 ? data.item.url.split('?')[0] : data.item.url;
  // const parentUrl = data.item.url.indexOf('?') > -1 ? data.item.url.split('?')[0] : data.item.url
  var newPath = {
    path: parentPath || '/',
    // component: data.children && data.children.length > 0 ? Layout : () => import('@/views' + data.item.url.toLowerCase()),
    component: data.children && data.children.length > 0 ? (data.item && data.item.parentId === null ? Layout : EmptyLayout) : () => import('@/views' + parentPath.toLowerCase()),
    meta: {
      title: data.item.name,
      sortNo: data.item.sortNo,
      // icon: changeIcon(data.item.iconName),
      icon: data.item.iconName || 'streamlist',
      elements: data.item && data.item.elements || '',
      url: data.item.url,
      msgCount: data.item.msgCount
    },
    childModelCode: data.item.code ? [data.item.code.toLowerCase()] : [],
    name: data.item.name,
    hidden: false,
    children: []
  };
  if (data.item.code && data.item.code.length > 0) {
    newmodules.push(newPath);
  }
  if (data.children && data.children.length > 0) {
    data.children.forEach(child => {
      newPath.children.push(groupRoutes(child));
      newPath.children.forEach(childitem => {
        newPath.childModelCode.push.apply(newPath.childModelCode, childitem.childModelCode);// 数组合并
      });
    });
  }
  return newPath;
};

const ResetModelMdgCount = (routers, modelCode, msgCount) => {
  if (routers && routers.length > 0) {
    routers.forEach(item => {
      if (item.childModelCode && item.childModelCode.length > 0 && item.childModelCode.includes(modelCode)) {
        item.meta.msgCount = (item.meta.msgCount + msgCount) < 0 ? 0 : item.meta.msgCount + msgCount;
        ResetModelMdgCount(item.children, modelCode, msgCount);
      }
    });
  }
};
const newmodules = [];
const permission = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
    SET_MODULELIST: (state, modules) => {
      state.modulelist = modules;
    },
    // 修改数量 参数为对象 {msgCount:0,modelCode:BaseMessage}
    SET_ROUTERSCOUNT: (state, modelObj) => {
      const objkeys = Object.keys(modelObj);
      if (objkeys.includes('msgCount') && objkeys.includes('modelCode')) {
        ResetModelMdgCount(state.routers, modelObj.modelCode.toLowerCase(), modelObj.msgCount);
      }
    }
  },
  actions: {

    GenerateRoutes({ commit }, data) {
      console.log(data);
      return new Promise(resolve => {
        (async() => {
          const newPaths = [];
          await data.modules.forEach((value) => {
            newPaths.push(groupRoutes(value));
          });
          commit('SET_ROUTERS', newPaths);
          commit('SET_MODULELIST', newmodules);
          // console.log('newPaths', newPaths)
          resolve(newPaths);
        })();
      });
    }
  }
};

export default permission;
